const defaultState = {
  socketConnection: false,
  webUrl: "fgfgfgf",
  viewerWebUrl: false,
  viewerBranch: false,
  howToPlay: false,
  slide_QR: false,
  volume: 0.125,
  active_game: null,
  play_again: false,
  myTeamUsers: [],
  magicLink: false,
  editions: [],
  LT: {},
  invitedPlayers: [],
  challengesComponent: "challenges-library"
};

const socketReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_SOCKET": {
      return {
        ...state,
        socketConnection: action.data
      };
    }
    case "SET_ACTIVE_GAME": {
      return {
        ...state,
        active_game: action.data
      };
    }
    case "SET_VIEWER_WEB_URL": {
      return {
        ...state,
        viewerWebUrl: action.data
      };
    }
    case "BNG_VOLUME": {
      return {
        ...state,
        volume: action.data
      };
    }
    case "SET_EDITIONS": {
      return {
        ...state,
        editions: action.data
      };
    }
    case "SET_INVITED_PLAYERS": {
      return {
        ...state,
        invitedPlayers: action.data
      };
    }
    case "SET_CHALLENGES_COMPONENT": {
      return {
        ...state,
        challengesComponent: action.data
      };
    }
    case "SET_LT_PARAMETERS": {
      return {
        ...state,
        LT: action.data
      };
    }
    case "SET_WEB_URL": {
      return {
        ...state,
        webUrl: action.data
      };
    }
    case "SET_BRANCHLINK_VIEER": {
      return {
        ...state,
        viewerBranch: action.data
      };
    }
    case "TOGGLE_HOW_TO_PLAY": {
      return {
        ...state,
        howToPlay: action.data
      };
    }
    case "SET_MAGIC_LINK": {
      return {
        ...state,
        magicLink: action.data
      };
    }
    case "TOGGLE_SLIDEKICK_QR": {
      return {
        ...state,
        slide_QR: action.data
      };
    }
    case "TOGGLE_PLAY_AGAIN": {
      return {
        ...state,
        play_again: action.data
      };
    }

    default:
      return state;
  }
};

export default socketReducer;
